import { Button, Container } from '@mui/material'
import React, { useContext } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { useCuestionario } from "../hooks/useCuestionario"
import FinalizarCuestionario from '../components/FinalizarCuestionario'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import FirstPageIcon from "@mui/icons-material/FirstPage"
import { TooltipButton } from '../components/commons/TooltipButton'
import { useTranslation } from "react-i18next"
import { styled } from '@mui/material/styles'
import { Titulo } from '../components/commons/Titulo'
import { EjesSkeleton } from '../components/commons/EjesSkeleton'
import { EjesContext } from '../context/EjesContext'
import { GeneralContext } from '../context/GeneralContext'
import ClearIcon from '@mui/icons-material/Clear'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import { useContestaciones } from '../hooks/useContestaciones'
import { useState, useEffect } from 'react';
import { useUser } from '../hooks/useUser.jsx';
import { useNavigate } from 'react-router-dom';
import { DobleCircularProgressWithLabel } from '../components/commons/DobleCircularProgressWithLabel';
import { PercentageBarLabel } from '../components/commons/PercentageBarLabel';
import ReplayIcon from '@mui/icons-material/Replay';
import { Box, Stack } from '@mui/system';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import LoadingButton from '@mui/lab/LoadingButton'
import ModalConfirmar from '../components/commons/ModalConfirmar'
import "../styles/Ejes.css";
import Modal from '../components/commons/Modal'
import { RadarChart } from "../components/Radar.jsx"
import { useSecurity } from "../hooks/useSecurity";

const IconButton = styled(Button)(({ theme }) => ({
    padding: '6px 6px',
    minWidth: '30px'
}));

export const Ejes = () => {
    const { getEjesCuestionario, anularEje, activarEje } = useCuestionario()
    const { reiniciarEje } = useContestaciones()
    const [listaEjes, setListaEjes] = useState()
    const { user } = useUser()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { handleOpenFinalizarCuestionario, loading, setLoading, GetCuestionarioReportEje, GetCuestionarioReportParcial } = useContext(EjesContext)
    const { setIdAxe, setQuestionaryPercentage } = useContext(GeneralContext)
    const [open, setOpen] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false)
    useSecurity();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function goToTema(axe) {
        setIdAxe(axe)
        navigate('/Cuestion')
    }
    function volverAMisCuestionarios() {
        navigate("/MisCuestionarios")
    }

    const handleShowInfoModal = () => {
        setShowInfoModal(true)
    }

    function reiniciarEjeFunction(idEje) {
        reiniciarEje(user, idEje)
        .then(
            (ejes) => {
                setListaEjes(ejes)
            },
            (y) => {
                console.error("Error: " + y)
            }
        );
    }

    function anularEjeFunction(idEje) {
        anularEje(user, idEje)
        .then(
            (ejes) => {
                setListaEjes(ejes)
            },
            (y) => {
                console.error("Error: " + y)
            }

        );
    }

    function activarEjeFunction(idEje) {
        activarEje(user, idEje)
        .then(
            (ejes) => {
                setListaEjes(ejes)
            },
            (y) => {
                console.error("Error: " + y)
            }
        );
    }

    useEffect(() => {
        if (user) {
            getEjesCuestionario(user)
            .then(
                (ejes) => {
                    setListaEjes({...ejes})
                    setQuestionaryPercentage(ejes.porcentajeCuestionario)
                },
                (promiseError) => {
                    console.error("Error: " + promiseError)
                }
            );
        }
    }, [user]);

    useEffect(() => {
        if (listaEjes && listaEjes.porcentajeCuestionario === 100) {
            setOpen(true);
        }
    }, [listaEjes])

    const [loadingButtons, setLoadingButtons] = useState({}); 


    const handlePdfClick = async (id_tema, eje) => {
        setLoadingButtons(prev => ({ ...prev, [id_tema]: true })); 

        try {
            await GetCuestionarioReportEje(listaEjes.id_cuestionario, eje);
        } catch (error) {
            console.error("Error al obtener el cuestionario:", error);
        } finally {
            setTimeout(() => {
                setLoadingButtons(prev => ({ ...prev, [id_tema]: false }));
            }, 1500); 
        }
    };



    return (
        <Container>
            <Grid container
                direction="column"
                justifyContent="center"
            >
                <Grid item xs={12} marginTop={'1em'}>
                    <Button
                        variant="contained"
                        startIcon={<FirstPageIcon icon={FirstPageIcon} />}
                        onClick={volverAMisCuestionarios}
                    >
                        {t("eje.btnVolver")}
                    </Button>
                </Grid>

                <Grid item xs={12} >
                    <Titulo titulo={t("eje.titulo")} size={"2.5em"} />
                </Grid>

                <Grid item className='ejesBody'>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                        sx={{ width: "80%", margin: "0 auto" }}
                    >
                        <Grid item xs={12} sx={{ marginBottom: "2em", textAlign: 'center' }}>
                            {listaEjes?.porcentajeCuestionario > 0 && (
                                <>
                                    <Typography
                                        variant="h5"
                                        color="primary"
                                        sx={{
                                            marginBottom: "1em",
                                            fontSize: "1.5em",
                                        }}
                                    >
                                        {t("general.porcentajeTotal")}
                                    </Typography>
                                    <DobleCircularProgressWithLabel percentage={listaEjes.porcentajeCuestionario} size={150} fontSize={"2em"} />

                                </>
                            )}

                        </Grid>
                        {/* TODO TOMAS solucionar, cambiar sx por estilos ya creados en home */}
                        {listaEjes ? (
                            <>
                                {listaEjes.temas.map(eje =>
                                    <Grid item xs={12} sm={6} md={4} lg={4} key={eje.id_tema} >
                                        <Card className='card' onClick={() => { goToTema(eje.id_tema) }}
                                            sx={{
                                                backgroundColor: eje.disable && "#f2f2f2",
                                                pointerEvents: eje.disable && "none",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: eje.porcentaje > 0 ? "space-around" : "center",
                                                minHeight: "210px",
                                                cursor: 'default',
                                                '&:hover': {
                                                    cursor: 'pointer'
                                                },
                                            }} >
                                            <CardContent>
                                                <img src={require("../images/temas/"+eje.key+".png")} loading='lazy' alt="alt" style={{filter: eje.disable? "grayscale(1)":"none"}} />
                                                <Typography variant="h5" component="div" style={{ fontSize: '1.3em' }}>
                                                    {eje.texto}
                                                </Typography>
                                            </CardContent>
                                            <Box marginBottom={"1em"} marginX={"1em"}>
                                                {eje.porcentaje > 0 && (
                                                    <PercentageBarLabel altura={10} percentage={eje.porcentaje} />
                                                )}
                                            </Box>
                                        </Card>
                                        <Stack flexDirection={"row"} marginY={1} justifyContent={!eje.disable ? "space-between" : "flex-start"}>
                                            <Stack flexDirection={"row"} gap={1}>
                                                {eje.porcentaje == 100 && (
                                                    <TooltipButton
                                                        titulo={t("eje.pdfTooltipTitle")}
                                                        body={t("eje.pdfTooltipBody")}
                                                    >
                                                        <LoadingButton
                                                            onClick={() => handlePdfClick(eje.id_tema, eje)}
                                                            sx={{ padding: '0px 18px' }}
                                                            loading={loadingButtons[eje.id_tema]}
                                                            variant="contained"
                                                            endIcon={<PictureAsPdf />}
                                                            loadingPosition="end"
                                                        >
                                                            PDF
                                                        </LoadingButton>
                                                    </TooltipButton>
                                                )}
                                                {!eje.disable && (
                                                    <TooltipButton
                                                        titulo={t("eje.continuarTooltipTitle")}
                                                        body={t("eje.continuarTooltipBody")}

                                                    >

                                                        <IconButton variant='contained' onClick={() => { goToTema(eje.id_tema) }}>
                                                            <ArrowForwardIcon />
                                                        </IconButton>
                                                    </TooltipButton>
                                                )}
                                            </Stack>
                                            <Stack flexDirection={"row"} gap={1}>
                                                {eje.porcentaje > 0 && (
                                                    <>
                                                        <ModalConfirmar
                                                            title={t("eje.modalReinciarEjesTitulo")}
                                                            text={t("eje.modalReiniciarEjesTexto")}
                                                            cancelText={t("general.cancelar")}
                                                            continueText={t("misCuestionarios.continuar")}
                                                            onContinue={() => { reiniciarEjeFunction(eje.id_tema) }}
                                                        >
                                                            <TooltipButton
                                                                titulo={t("eje.reiniciarTooltipTitle")}
                                                                body={t("eje.reiniciarTooltipBody")}
                                                            >
                                                                <IconButton color={"error"} variant='contained'>
                                                                    <ReplayIcon />
                                                                </IconButton>
                                                            </TooltipButton>
                                                        </ModalConfirmar>
                                                    </>
                                                )}
                                                {!eje.disable ? (
                                                    <>
                                                        {console.log(listaEjes)}
                                                        <ModalConfirmar
                                                            title={t("eje.desactivarEjePregunta")}
                                                            text={t("eje.desactivarEjeBody")}
                                                            cancelText={t("cuestion.btnCancelar")}
                                                            continueText={t("misCuestionarios.continuar")}
                                                            onContinue={() => { anularEjeFunction(eje.id_tema) }}
                                                            envuelveBoton={listaEjes.isMaxAnulados}
                                                        >
                                                            <TooltipButton
                                                                titulo={listaEjes.isMaxAnulados ? t("eje.maxAnuladosTitle").toUpperCase() : t("eje.anularEjeTooltipTitle").toUpperCase()}
                                                                body={listaEjes.isMaxAnulados ? t("eje.maxAnuladosBody") : t("eje.anularEjeTooltipBody")}
                                                            >
                                                                <IconButton color={listaEjes.isMaxAnulados ? "inherit" : "error"} variant='contained'>
                                                                    <ClearIcon sx={{ color: listaEjes.isMaxAnulados && "#a9a9a9" }} />
                                                                </IconButton>
                                                            </TooltipButton>
                                                        </ModalConfirmar>

                                                    </>
                                                ) : (
                                                    <TooltipButton
                                                        titulo={t("eje.activarEjeTooltipTitle")}
                                                        body={t("eje.activarEjeTooltipBody")}
                                                    >
                                                        <IconButton color={"primary"} variant='contained' onClick={() => { activarEjeFunction(eje.id_tema) }}>
                                                            <PowerSettingsNewIcon />
                                                        </IconButton>
                                                    </TooltipButton>
                                                )}
                                            </Stack>
                                        </Stack>
                                    </Grid>
                                )}

                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", marginY: '3rem' }}>
                                    <Stack spacing={2} direction="row" >
                                        <TooltipButton
                                            titulo={t("eje.informeParcialTitle")}
                                            body={t("eje.informeParcialBody")}
                                        >
                                            <LoadingButton
                                                onClick={() => {
                                                    setLoading(true);
                                                    GetCuestionarioReportParcial(listaEjes.id_cuestionario);
                                                }}
                                                sx={{ padding: '0px 18px' }}
                                                loading={loading}
                                                variant="contained"
                                                endIcon={<PictureAsPdf />}
                                                loadingPosition="end"
                                                disabled={listaEjes?.temas?.filter(eje => eje.porcentaje === 100)?.length === 0}
                                            >
                                                {t("eje.botonReportParcial")}
                                            </LoadingButton>
                                        </TooltipButton>
                                        <Button onClick={handleOpenFinalizarCuestionario} variant='contained' sx={{ padding: "0.5em" }} disabled={listaEjes.porcentajeCuestionario !== 100 && true}>
                                            {t("eje.botonFinalizar")}
                                        </Button>
                                        <Button variant="contained" className="botonAyuda" onClick={handleShowInfoModal}>
                                            ?
                                        </Button>
                                    </Stack>
                                    {listaEjes?.porcentajeCuestionario === 100 &&
                                        < FinalizarCuestionario idCuestionario={listaEjes.id_cuestionario} />
                                    }
                                </Grid>
                                <Modal title={t("eje.tituloObtenerInformeGlobal")} content={t("eje.bodyObtenerInformeGlobal")} open={showInfoModal}>
                                    <Button variant="contained" onClick={() => { setShowInfoModal(false) }} >{t("general.aceptar")}</Button>
                                </Modal>
                                <Modal title={""} content={t("eje.listaEjes100Modal")} open={open} close={handleClose} >
                                    <Button onClick={handleClose}>{t('general.cerrar')}</Button>
                                </Modal>

                                {/*Este radar se crea en oculto para que salga en el pdf parcial */}
                                {listaEjes?.puntuacionTema?.length >= 3 &&
                                    <Box sx={{
                                        position: "absolute", zIndex: -99, height: { xs: 'auto', md: '550px' }, display: 'flex', alignContent: 'center', justifyContent: 'center'
                                    }}>
                                        <RadarChart puntuacionesTemas={listaEjes.puntuacionTema} calification={"B"} />
                                    </Box>
                                }
                            </>
                        ) : (
                            <EjesSkeleton />
                        )}

                    </Grid>

                </Grid>

            </Grid >

        </Container>
    )
}
